import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'src/app/_alert';
import { CommonService } from 'src/app/_services/common.service';
import { PaymentService } from 'src/app/_services/payment.service';
import { CancelPaymentSuccessComponent } from '../cancel-payment-success/cancel-payment-success.component';

@Component({
  selector: 'app-confirm-cancel-payment',
  templateUrl: './confirm-cancel-payment.component.html',
  styleUrls: ['./confirm-cancel-payment.component.css']
})
export class ConfirmCancelPaymentComponent implements OnInit {
  isLoading: boolean = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConfirmCancelPaymentComponent>,
    public paymentService: PaymentService,
    public commonService: CommonService,
    public alertService: AlertService
  ) { }

  ngOnInit(): void {
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onClick() {
    this.paymentService.cancelPayment(this.data.cancelData).subscribe((response: any) => {
      console.log(response);
      const dialogRef = this.dialog.open(CancelPaymentSuccessComponent, {
        width: '600px',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
      });
      this.alertService.info(response.responseDescription, this.options);
    }, (err) => {
      this.alertService.error(err, this.options);
    })
  }
}
